<template>
  <span>
    <span>
      {{genereText}}
    </span>
    <i class="icon-dotted"></i>
    <span>{{Math.floor(contentInfo.playtime /60)}}분</span>
  </span>
</template>
<script>
import { get } from 'lodash'
export default {
  name: 'MovieGenre',
  props: ['contentInfo'],
  computed: {
    genereText () {
      return get(this.contentInfo, ['genre', 'list', '0', 'text'], '')
    }
  }
}
</script>
